export const items = [
  {
    value: 0,
    href: 'https://bit.ly/2Twz2Rq',
    email: 'andrew@collab.net',
    label: 'james andrew smith',
  },
  {
    value: 1,
    href: 'https://bit.ly/2Twz2Rq',
    email: 'andrew@collab.net',
    label: 'andrew smith',
  },
  {
    value: 2,
    href: 'https://bit.ly/2Twz2Rq',
    email: 'letyze@collab.net',
    label: 'andrew letyze',
  },
  {
    value: 3,
    href: 'https://bit.ly/2Twz2Rq',
    email: 'tadaboy@collab.net',
    label: 'Tosin',
  },
  {
    value: 4,
    href: 'https://bit.ly/2Twz2Rq',
    email: 'kmarsh@collab.net',
    label: 'Kristen',
  },
  {
    value: 5,
    href: 'https://bit.ly/2Twz2Rq',
    email: 'wsmith@collab.net',
    label:
      "Name so very very long that I can't event begin to render the entire name without clamping with a dot dot dot",
  },
];
